import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { VolcanicSvgComponent } from './volcanic-legend-svg/volcanic-legend-svg';

export const VOLCANIC_LEGEND: TwcLegendParams = {
  title: 'VOLCANIC',
  legendTitleBarInfo: signal('0'),
  data: {
    svgComponent: VolcanicSvgComponent,
    pluginIDs: ['volcanic-points', 'volcanic-ash-clouds']
  },
  legendComponent: TwcLegendComponent
};
